module.exports = __webpack_public_path__ + "static/media/modal-backer.eaf55606.png";